module.exports = __webpack_public_path__ + "static/img/8.ce449ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/eng/8.png
// module id = 6Wa8
// module chunks = 0